// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3vR9_","additionalInfo":"AgreementModal_additionalInfo__2X8pD"};